import { Card, CardActionArea, CardContent, Chip, Divider, Grid, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { createElement } from "react";
import * as MuiIcons from '@mui/icons-material';


const DynamicDashboardLayout = ({ dashBoardData }: any) => {
    const navigate = useNavigate()
    return (
        <Grid container spacing={3} sx={{ mt: 0 }}>
            {dashBoardData?.map((item: any, index: number) =>
                <Grid item md={item.size} key={index}>
                    <Card className="dashboardCard">
                        <CardContent className="textCenter">
                            <CardActionArea onClick={() => item.navigate && navigate(item.navigate)}>
                                <IconButton aria-label={item?.title} className="dashboardIcon">
                                    {item.icon && createElement((MuiIcons as any)[item.icon])}
                                </IconButton>
                                <Typography
                                    variant="h6"
                                    component="div"
                                    gutterBottom
                                    className="pt2"
                                >
                                    {item.title}
                                </Typography>
                            </CardActionArea>
                            <br />
                            <List>
                                {item.list?.map((listItem: any, index: number) =>
                                    <>
                                        {listItem?.map((listItemContent: any, index: any) =>
                                            <ListItem
                                                secondaryAction={
                                                    <>
                                                        <Stack direction="row" spacing={1}>
                                                            <Chip color={listItemContent?.color} label={listItemContent?.count} size="small" />
                                                        </Stack>
                                                    </>
                                                }
                                                disablePadding
                                                key={index}
                                            >
                                                <ListItemText primary={listItemContent?.status} />
                                            </ListItem>
                                        )}
                                        {item.list && item.list.length > 0 && (item.list.length - 1) != index && <Divider sx={{ my: 1 }} />}
                                    </>
                                )}

                            </List>
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>
    )
}

export default DynamicDashboardLayout